import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Portfolio } from '../../types/entities';

import { PortfolioState, initialPortfolioState } from './state';

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState: initialPortfolioState,
  reducers: {
    reset: () => initialPortfolioState,
    loading: (state: PortfolioState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    success: (state: PortfolioState, action: PayloadAction<Portfolio[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.portfolios = action.payload;
    },
    fail: (state: PortfolioState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.portfolios = [];
    },
    add: (state: PortfolioState, action: PayloadAction<{ conId: number }>) => {
      state.portfolios.push({
        conId: action.payload.conId,
        size: 0,
        marketPrice: 0,
        marketValue: 0,
        unrealizedPnl: 0,
        marketTradingHours: 0
      });
      state.loading = false;
      state.loaded = true;
    }
  }
});

const { actions, reducer } = portfolioSlice;
export const { reset, loading, success, fail, add } = actions;
export default reducer;
